<div [ngClass]="['help' + (hasFooter ? '-footer' : '') + '-container']">
  <iframe
    #helpframe
    frameborder="0"
    height="100%"
    id="helpframe"
    sandbox="allow-same-origin allow-top-navigation allow-scripts"
    width="100%"
    [src]="frameUrl"
    (load)="onFrameLoad()">
  </iframe>
</div>
